export enum OrganizationRole {
  ADMIN = "admin",
  MEMBER = "member",
}
